import { Component, HostBinding, HostListener, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MenuItem } from 'primeng/api';
import { StyleClassModule } from 'primeng/styleclass';
import { ButtonModule } from 'primeng/button';
import { AuthService } from 'src/app/shared/services/auth.service';
import { IUserState, UserStoreService } from 'src/app/shared/services/store/user-store.service';
import { UserMenuItemComponent } from 'src/app/shared/components/menu-components/user-menu-item/user-menu-item.component';
import { ModalService } from 'src/app/shared/services/modal.service';
import { AuthModalComponent } from 'src/app/shared/modals/auth-modal/auth-modal.component';
import { AuthComponentState } from 'src/app/shared/components/auth/auth.component';
import { DeviceSize, SystemService } from 'src/app/shared/services/system.service';
import { NavigationService } from 'src/app/shared/services/navigation.service';
import { LP_CREATE_EVENT_ID } from '../lp-create-event/lp-create-event.component';
import { LpCreateEventService } from '../lp-create-event/lp-create-event.service';
import { IUser } from 'src/app/shared/models/user/user.model';

@Component({
  selector: 'app-lp-menu',
  standalone: true,
  imports: [CommonModule, StyleClassModule, ButtonModule, UserMenuItemComponent],
  templateUrl: './lp-menu.component.html',
  styleUrls: ['./lp-menu.component.scss']
})
export class LpMenuComponent implements OnInit {
  DeviceSize = DeviceSize;

  userState: IUserState | undefined;

  basicMenuItems: MenuItem[] = [
    {
      label: 'Ceny',
      command: () => { this.scrollToId('pricing')  }
    },
    {
      label: 'Funkce',
      command: () => { this.scrollToId('features')  }
    },
    {
      label: 'Časté dotazy',
      command: () => { this.scrollToId('faq') }
    },
  ];
  signInItem: MenuItem = {
    label: 'Přihlásit se',
    icon: 'pi pi-sign-in',
    command: () => {
      this.modalService.openAuthModal({
        c: AuthModalComponent,
        title: "admin.authmodal.login.title",
        state: AuthComponentState.SIGN_IN,
        setRedirectAfterLoad: true
      })
    }
  };

  prevScrollpos = window.scrollY;
  currentHeight: number = 0;
  @HostBinding('style.top') top: string = '0px';

  @HostListener('window:scroll', ['$event'])
  onResize(event: Event) {
    const currentScrollPos = window.scrollY;
    if (this.prevScrollpos > currentScrollPos || window.scrollY < this.currentHeight) {
      this.top = '0px';
    } else {
      this.top = -this.currentHeight + 'px';
    }
    this.prevScrollpos = currentScrollPos;
  }

  constructor(
    private authService: AuthService,
    private userStore: UserStoreService,
    private modalService: ModalService,
    private sysService: SystemService,
    private navService: NavigationService,
    private lpCreateEventService: LpCreateEventService
  ) { }

  ngOnInit(): void {
    this.userState = this.userStore.state;

    this.watchMenuHeight();
  }

  /**
 * watches menu height and sets body's margin top to its height dynamically
 */
  watchMenuHeight() {
    const menu = document.querySelector('app-lp-menu');

    const resizeObserver = new ResizeObserver(entries => {
      entries.forEach(entry => {
        if (entry.target === menu) {
          const height = entry.contentRect.height;
          this.currentHeight = height;
          document.body.style.paddingTop = height + 'px';
        }
      });
    });

    if (menu) resizeObserver.observe(menu);
  }

  onCreateCourse() {
    this.lpCreateEventService.focusTitleInput.next();
    setTimeout(() => {
      const myElement = document.getElementById(LP_CREATE_EVENT_ID);
      myElement?.scrollIntoView({ behavior: "smooth", block: "center" });
    }, 1);
  }

  scrollToId(id: string) {
    const myElement = document.getElementById(id);
    myElement?.scrollIntoView({ behavior: "smooth", block: 'start' });
  }

  onGoToAdmin(user: IUser) {
    this.navService.goToUsersDashboard(user);
  }

  onDemo() {
    this.navService.goToArrangeMeeting();
  }

  get deviceSize$() {
    return this.sysService.deviceSize$;
  }
}
